import React from 'react'
import style from './logo.module.scss'
import cx from 'classnames'
import LogoBig from '../../resources/assets/images/ibanfirst-logo.svg'
import LogoSmall from '../../resources/assets/images/ibanfirst-logo-small.svg'
import { PropTypes } from 'prop-types'

/**
 * Logo component of the header
 */
const Logo = ({ className, height = 30 }) => {
	return (
		<div className={cx(className, style.logo)}>
			<img className={style.big} src={LogoBig} height={height} alt={'iBanFirst'} />
			<img className={style.small} src={LogoSmall} height={height} alt={'iBanFirst'} />
		</div>
	)
}

Logo.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Height of the item */
	height: PropTypes.number
}

export { Logo }
